export default __webpack_public_path__ + "static/test-tutorial-it-0fdcf73b83c2dee7adc0e909df3edf98.mp4";